const { noteLocalWrite } = require("../sync/cache");

export default {
    get(key) {
        return JSON.parse(localStorage.getItem(key))
    },
    set(key, obj) {
        localStorage.setItem(key, JSON.stringify(obj));
        if (key === "config" || key === "customTodoListIds") {
            noteLocalWrite(key);
        }
    },
    remove(key) {
        localStorage.removeItem(key);
    },
    clean(){
        var keys = Object.keys(localStorage), i = keys.length;
        while (i--) {
            if (keys[i] === "syncMeta") continue;
            localStorage.removeItem(keys[i]);
        }
    },
    as_json(){
        var values = {}, keys = Object.keys(localStorage), i = keys.length;
        while (i--) {
            values[keys[i]] = localStorage.getItem(keys[i]);
        }
        return values;
    },
    load_json(data){
        localStorage.setItem('config',data['config'])
        localStorage.setItem('customTodoListIds',data['customTodoListIds'])
        noteLocalWrite("config");
        noteLocalWrite("customTodoListIds");
    },
};